export const ALERT_APPEND = 'ALERT_APPEND';
export const ALERT_REMOVE = 'ALERT_REMOVE';
